import React from 'react';
import {
  Box,
  VStack,
  Skeleton,
  Separator,
} from '@chakra-ui/react';
import Card from './ui/Card';

interface LoadingSkeletonProps {
  rows?: number;
  height?: string;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({
  rows = 3,
  height = "60px",
}) => {
  return (
    <Card>
      <VStack gap={0} align="stretch">
        {/* Header Skeleton */}
        <Box bg="gray.50" _dark={{ bg: "gray.800" }} px={4} py={3} borderTopRadius="md">
          <Skeleton height="20px" />
        </Box>
        
        {/* Header Separator */}
        <Separator />
        
        {/* Content Skeletons */}
        {Array.from({ length: rows }).map((_, index) => (
          <React.Fragment key={index}>
            <Box px={4} py={5}>
              <Skeleton height={height} />
            </Box>
            {/* Row Separator */}
            {index < rows - 1 && <Separator />}
          </React.Fragment>
        ))}
      </VStack>
    </Card>
  );
};

export default LoadingSkeleton; 